import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet } from 'z3k-parser/lib/flags';
export var DigitalDut;
(function (DigitalDut) {
    let Type;
    (function (Type) {
        Type[Type["RS_485"] = 1] = "RS_485";
        Type[Type["K_LINE"] = 2] = "K_LINE";
    })(Type = DigitalDut.Type || (DigitalDut.Type = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["FROM_OBD"] = 16] = "FROM_OBD";
    })(Flags = DigitalDut.Flags || (DigitalDut.Flags = {}));
    DigitalDut.TypeOptions = [
        { text: 'RS-485', value: Type.RS_485 },
        { text: 'K-LINE', value: Type.K_LINE },
    ];
    function isFromOBD(dut) {
        return isFlagSet(dut, Flags.FROM_OBD);
    }
    DigitalDut.isFromOBD = isFromOBD;
    function isRS485(dut) {
        return dut.type === Type.RS_485;
    }
    DigitalDut.isRS485 = isRS485;
    DigitalDut.get = createAccessors(arrayGetSet('digital_duts'), {
        serial: '0',
        name: 'Цифровой ДУТ',
        type: Type.RS_485,
        setting_register: 1,
        rol_connection_lost: [],
        no_connection_timeout: 1,
        calibration: -1,
        egts: 0,
    });
})(DigitalDut || (DigitalDut = {}));
